import MediaControl from './media-control'

const ImageControl = (function ($) {
  return MediaControl.extend({

  })
})(jQuery)

export default ImageControl
